export const RESOURCE = 'adminmembershiptype';
export const ACTIONS = { Get: '', Update: '', Create: '' }